import axios from '@/plugins/axios'

class ReportService {
  async getMyReport() {
    const { data } = await axios.get('/sum/api/report')
    return data
  }

  async getMyReportMissionComplete() {
    const { data } = await axios.get('/sum/api/free/report')
    return data
  }

  async shareMyReport() {
    const { data } = await axios.post('/sum/api/report/share')
    return data
  }

  async getShareReport(code) {
    const { data } = await axios.post(`/sum/api/report/share/${code}`)
    return data
  }
}

export default new ReportService()
